import { JSX, useState } from 'react'
import { useNavigate } from 'react-router'

import { Button, Text } from '@chakra-ui/react'

import { RxPlus } from 'react-icons/rx'


import { Router } from '@/views/supervisor'

// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Layout from '@/components/layout.tsx'
// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Drawer from '@/components/ui/drawer.tsx'

import update from '@/views/supervisor/archive/components/update.tsx'

// eslint-disable-next-line @typescript-eslint/naming-convention
import Loader from './components/loader.tsx'
import delete_ from './components/delete.tsx'




// eslint-disable-next-line @typescript-eslint/naming-convention
export function Toolbar
(
	props: {
		search(v: string, input: boolean): void

	},

)
:	JSX.Element
{
	let [keyword, update_keyword] = useState('')

	let on_change = (v: string): void =>
	{
		update_keyword(v)

		props.search(v, true)

	}

	let on_enter = (): void =>
	{
		props.search(keyword, false)

	}

	let on_filter = (): void =>
	{
		Drawer.open(
			<></>,

			{ size: 'sm', title: '筛选' },

		)

	}

	let on_create = (): void =>
	{
		Drawer.open(
			<></>,

			{ size: 'lg', title: '添加员工' },

		)

	}

	return (
		<>
			<Layout.Search placeholder="请输入员工姓名" value={keyword} change={on_change} enter={on_enter} />

			<Layout.Filter open={on_filter}>
				<Button colorPalette="blue" rounded="md" onClick={on_create}>
					<RxPlus />
					<Text>添加员工</Text>
				</Button>
			</Layout.Filter>

		</>

	)


}

export default function
(
	props: {
		_id: string

	},

)
:	JSX.Element
{
	let navigate = useNavigate()

	let [search, update_search] = useState('')

	let on_search = (v: string, input: boolean): void =>
	{
		if (input)
		{
			return

		}

		update_search(v)

	}


	let on_view = (_id: string): void =>
	{
		// eslint-disable-next-line @typescript-eslint/no-floating-promises
		navigate(`./${Router.archive}/${_id}`)

	}

	let on_update = (_id: string): void =>
	{
		update(_id)

	}

	let on_delete = (_id: string, name: string): void =>
	{
		delete_(_id, name)

	}


	return (
		<Loader _id={props._id} keyword={search} view={on_view} update={on_update} delete={on_delete} />

	)

}
